import { BoxBase, StackBase } from '@fmc-digital/ui';
import React from 'react';
import { BundleOfferSkeleton, MarketingSurveySkeleton, NewLoanInProgressSkeleton, PaymentCardSkeleton } from '../atoms/skeletons';
import { withHeaderFooter } from '../../HOCs';

export const DashboardLoader = () => {
    return (
        <BoxBase maxWidth="xl" sx={{ padding: { xs: '1rem', sm: '2rem' }, width: '100%', margin: '0 auto' }}>
            <StackBase gap={{ xs: '1rem', sm: '2rem' }} direction={{ xs: 'column', sm: 'row' }}>
                <StackBase gap={{ xs: '1rem', sm: '2rem' }} width={{ xs: '100%', sm: '50%' }}>
                    <PaymentCardSkeleton />
                    <BundleOfferSkeleton />
                    <BundleOfferSkeleton />
                    <MarketingSurveySkeleton />
                </StackBase>
                <StackBase gap={{ xs: '1rem', sm: '2rem' }} width={{ xs: '100%', sm: '50%' }}>
                    <NewLoanInProgressSkeleton />
                    <BundleOfferSkeleton bgColor="teal" />
                    <BundleOfferSkeleton bgColor="teal" />
                    <BundleOfferSkeleton />
                    <BundleOfferSkeleton />
                </StackBase>
            </StackBase>
        </BoxBase>
    );
};

export const DashboardLoadingScreen = withHeaderFooter(DashboardLoader, { showDropDownOptions: false, showMenuOptions: false });
